import Types from "./Types";

export const GetPromoCodesSuccess = (payload) => ({
  type: Types.GET_PROMO_CODES_SUCCESS,
  payload,
});

export const PromoCodesLoading = (payload) => ({
  type: Types.PROMO_CODES_LOADING,
  payload,
});

export const GetPromoCodeDetailsSuccess = (payload) => ({
  type: Types.GET_PROMO_CODE_DETAILS_SUCCESS,
  payload,
});
